// extracted by mini-css-extract-plugin
export default {"root":"NotificationTitle_root__1O98d"};